import { Flex, Typography } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import { useAudioStatusCheck } from "../../hooks/useAudioStatusCheck";
import { getNotesList } from "../../service/notes.service";
import { setCurrentPage, setLoadingNotesState } from "../../slices/appStateSlice";
import { eventEmitter } from "../../utils/eventEmitter";
import ClientSelector from "./ClientSelector.component";
import NotesSection from "./NotesSection.component";
import styles from "./home.module.scss";

const AllNotes = () => {
  const componentName = "home";
  const dispatch = useAppDispatch();
  const { notes, updateNotes: setNotes } = useAudioStatusCheck([]);
  const [totalNotes, setTotalNotes] = useState(0);
  const abortControllerRef = useRef<AbortController | null>(null);
  const { isNotesViewVisible, currentPage, selectedClient } = useAppSelector((state) => state.appState);

  const fetchNotes = useCallback(
    async (pageNumber = 1) => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      abortControllerRef.current = new AbortController();
      try {
        dispatch(setLoadingNotesState(true));
        const response = await getNotesList(pageNumber);
        const data = await response.data;
        setNotes(data?.results);
        setTotalNotes(data?.count);
        if (pageNumber) {
          dispatch(setCurrentPage(pageNumber));
        }
      } catch (error) {
        console.error("Error fetching notes:", error);
      } finally {
        dispatch(setLoadingNotesState(false));
      }
    },
    [dispatch, setNotes],
  );

  useEffect(() => {
    if (!isNotesViewVisible) {
      fetchNotes(currentPage);
    }
  }, [currentPage, fetchNotes, isNotesViewVisible]);

  const refreshHandler = useCallback(() => {
    fetchNotes(currentPage);
  }, [fetchNotes, currentPage]);

  useEffect(() => {
    eventEmitter.on("refreshNotes", refreshHandler);

    return () => {
      eventEmitter.off("refreshNotes", refreshHandler);
    };
  }, [refreshHandler]);

  return (
    <Flex className={!isNotesViewVisible ? styles[`${componentName}__container-left-allnotes`] : ""} vertical>
      {!selectedClient && !isNotesViewVisible ? (
        <Flex className={styles[`${componentName}__container-left-header`]}>
          <Typography className={styles[`${componentName}__container-left-header-title`]}>Past Notes</Typography>
          <ClientSelector />
        </Flex>
      ) : null}
      <NotesSection notes={notes} setNotes={setNotes} totalNotes={totalNotes} fetchNotes={fetchNotes} />
    </Flex>
  );
};

export default AllNotes;
